import { Controller } from "@hotwired/stimulus"

import { trackPlay } from "@/lib/ahoy"
import { trackContentPlay } from "@/lib/posthog"

// Tracks the first play event per content item to PostHog and Ahoy.
// Connects to data-controller="play-tracker"
export default class extends Controller {
  static values = {
    itemId: String,
    itemTitle: String,
    spaceId: String,
    spaceUrl: String,
    contentType: { type: String, default: "audio" },
    containerId: { type: String, default: "" },
  }

  declare itemIdValue: string
  declare itemTitleValue: string
  declare spaceIdValue: string
  declare spaceUrlValue: string
  declare contentTypeValue: "audio" | "video"
  declare containerIdValue: string

  private hasTrackedPlay = false

  // "First play" is per content item, not per connect: the unfurl player
  // (#1643) re-points this controller at the next track on one shared
  // transport rather than reconnecting, so without this every play after the
  // first would be swallowed — one wrongly-attributed play per session.
  // Stimulus also fires this once on connect, which is the old reset.
  itemIdValueChanged() {
    this.hasTrackedPlay = false
  }

  handlePlay() {
    if (!this.hasTrackedPlay) {
      const containerId = this.containerIdValue || undefined
      trackContentPlay(
        this.itemIdValue,
        this.itemTitleValue,
        this.spaceIdValue,
        this.spaceUrlValue,
        this.contentTypeValue,
        containerId,
      )
      trackPlay(
        this.itemIdValue,
        this.spaceIdValue,
        undefined,
        undefined,
        "web",
        "stream",
        containerId,
      )
      this.hasTrackedPlay = true
    }
  }
}
